<div class="flex_align_center delivery_info_block">
  <img [src]="'assets/images/icons/' + (data.type === 'deliveryPrice'? 'delivery_price_icon.svg' : 'delivery_time_icon.svg')">
  <div class="info">
    {{(data.useType === 'shop' && !isMobile) ? ' от ' : ''}} {{data.type === 'deliveryTime'?  (data.value + ' мин') :  (data.value + ' ₽')}}
  </div>
</div>
